var WxYiYuanGiftRedirector = xClass("WxYiYuanGiftRedirector", BaseRedirector)
WxYiYuanGiftRedirector.prototype.getName = function () {
    var self = this
    return "wxYiYuanGift"
}
WxYiYuanGiftRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
WxYiYuanGiftRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param

    //if (META.platform == XcloverPlatform.wechatgame) 
    {
        if (param.inviteCode) {
            let http = WxYiYuanGiftShareInHttp.new(false)
            // http.addEventListener(Events.kComplete, () => {
            //     Toast.make("成功帮好友获得5步")
            // })
            // http.addEventListener(Events.kError, (evt = {}) => {
            //     Toast.make(quickGetErrorText(evt.data, "帮助链接已经失效！"))
            // })
            http.load(param.inviteCode)
        }
    }
    return true
}
module.exports = WxYiYuanGiftRedirector